<template>
  <div>
    <h1 class="fs-1 fw-bold my-1">{{ title }}</h1>
    <p v-if="subtitle" class="lpg-title fs-3 text-secondary mb-4">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
  },
}
</script>
